module.exports = __webpack_public_path__ + "img/Arizona_The_Wave_iStock-960419974.94b65138.jpg";